import * as THREE from 'three';
import { StateManager } from "./statemanager";
import { State } from "./state";
import { DataManager, GDM } from "../helpers/datamanager";
import { LoginClient } from "../net/loginclient";
import { WorldClient, RESULT_CREATE_CHAR } from "../net/worldclient";
import { GameClient } from "../net/gameclient";
import { CharPawn } from "../pawns/charpawn";
import { AnimationData } from '../loaders/zmo';
import { SETTINGS } from '../settings';
import { AVTBODYPART } from '../constants';
import { enumToName } from '../util/generic';
import { CameraAnimator } from '../animators/cameraanimator';
import { LoadScreen } from '../helpers/loadscreen';

let activePass: any = null;

// ?autologin=true|false overrides config.autologin (hosted deploys set it to false).
const autologinParam = new URLSearchParams(location.search).get("autologin");
const autologin = autologinParam ? autologinParam !== "false" : config.autologin !== false;
const autologin_user = "test";
const autologin_pass = "test";

const autocharselect = false;
const autologin_serverId = 1;
const autologin_charname = "Admin";

const USE_LIVE_SERVER = false;
let serverIp = "127.0.0.1";
const port = 29000;
// var serverName = '!Pegasus';
if (USE_LIVE_SERVER) {
    serverIp = "128.241.92.36";
    //   serverName = '1Draconis';
}

export class LoginState extends State {
    DM: any;
    activeCamAnim: any;
    world: any;
    chars: any[];
    selectedCharIdx: number;
    visChars: any[];
    newsDialog: any;

    constructor() {
        super();
        this.DM = new DataManager();
    }

    async prepareOnce(): Promise<void> {
        // this.DM.register('canim_intro', AnimationData, 'CAMERAS/TITLEMAP_LOGIN.ZMO');

        // this.DM.register('canim_intro', AnimationData, '3DDATA/TITLE/CAMERA01_INGAME01.ZMO');
        this.DM.register(
            "canim_intro",
            AnimationData,
            "3DDATA/TITLE/CAMERA01_INTRO01.ZMO"
        ); // When you just joined the login screen you wiggle a bit
        // this.DM.register('canim_intro', AnimationData, '3DDATA/TITLE/CAMERA01_CREATE01.ZMO');

        // // this.DM.register('canim_inselect', AnimationData, 'CAMERAS/TITLEMAP_AVTLIST.ZMO');
        this.DM.register(
            "canim_inselect",
            AnimationData,
            "3DDATA/TITLE/CAMERA01_INSELECT01.ZMO"
        ); // When you log in and just joined the Character Select
        // this.DM.register('canim_outselect', AnimationData, 'CAMERAS/TITLEMAP_AVTLIST_RETURN.ZMO');
        this.DM.register(
            "canim_outselect",
            AnimationData,
            "3DDATA/TITLE/CAMERA01_OUTCREATE01.ZMO"
        ); // After you created your character you zoom out again

        this.DM.register(
            "canim_create",
            AnimationData,
            "3DDATA/TITLE/CAMERA01_CREATE01.ZMO"
        ); // When you click on Create Character
        this.DM.register(
            "canim_ingame",
            AnimationData,
            "3DDATA/TITLE/CAMERA01_INGAME01.ZMO"
        ); // When you select character and start loading the game

        // Start loading this, going to need it later.

        // GDM.get("zone_names", "list_zone", () => {
        // }); // TODO: Werd ergens hieronder ook al gedaan.. weet niet waarom twee keer
        GDM.get("zone_names", "list_zone", "list_status");

        GDM.get("char_motiontypes"); // Preload animation for when you selected your char

        // Preload character skeletons and common resources
        GDM.get("male_skel", "female_skel", "char_motions");

        await new Promise<void>((resolve) => {
            this.DM.get("canim_intro", () => {
                resolve();

                // Continue by preloading the rest for now.
                this.DM.get("canim_inselect");
                this.DM.get("canim_outselect");
            });
        });
    }

    protected generateLoadingTasks() {
        return [
            {
                name: "Loading login resources...",
                loader: async (onProgress: (progress: number) => void) => {
                    onProgress(0);

                    // Reset state variables
                    this.activeCamAnim = null;
                    this.chars = [];
                    this.selectedCharIdx = -1;
                    this.visChars = [];
                    this.newsDialog = null;
                    this.world = null;

                    onProgress(10);

                    // Ensure zone data is loaded before loading the map
                    // prepareOnce starts loading these, but we need to wait for completion
                    await new Promise<void>((resolve) => {
                        GDM.get("zone_names", "list_zone", "list_sky", () => {
                            onProgress(30);

                            // Load the login map using GZM (same as old LoadingLoginState)
                            const loginPos = new THREE.Vector3(5200, 5200, 0);
                            GZM.prepare(4, loginPos, () => {
                                onProgress(80);

                                // Add world to scene
                                GZM.addToScene();

                                onProgress(100);
                                resolve();
                            });
                        });
                    });
                },
            },
        ];
    }

    playNextAnim() {
        this.playCamAnim("canim_inselect", 1, undefined, undefined);
    }

    playCamAnim(name: any, loopCount: any, speed: any, callback: any) {
        this.DM.get(name, (zmoData: any) => {
            if (this.activeCamAnim) {
                this.activeCamAnim.stop();
                this.activeCamAnim = null;
            }

            this.activeCamAnim = new CameraAnimator(
                camera,
                zmoData,
                new THREE.Vector3(5200, 5200, 0)
            );
            if (speed !== undefined) {
                this.activeCamAnim.timeScale = speed;
            }
            this.activeCamAnim.play(loopCount);

            if (callback) {
                this.activeCamAnim.on("complete", callback);
            }
        });
    }

    enter() {
        LoadScreen.hide();

        // World is already created and loaded during prepare phase via GZM
        this.world = GZM.map;
        global.world = this.world;

        this.playCamAnim("canim_intro", undefined, undefined, undefined);

        // Show news dialog in login state
        this.newsDialog = ui.newsDialog();

        if (autologin) {
            // TODO: Remove later
            this._doneLogin(autologin_user, autologin_pass);
        } else {
            ui.loginDialog().on("done", (username: any, password: any) => {
                this._doneLogin(username, password);
            });
        }
    }
    _doneLogin(rUser: any, rPass: any) {
        activePass = rPass;

        let waitDialog = ui.statusDialog();
        waitDialog.setMessage("Connecting...");

        netLogin = new LoginClient();
        netLogin.connect(serverIp, port, (err: any) => {
            waitDialog.setMessage("Authenticating...");

            netLogin.login(rUser, rPass, (data: any) => {
                if ((data.result & 0x7f) !== NETLOGINREPLY.OK) {
                    waitDialog.setMessage(
                        "Failed to Login (" +
                            enumToName(NETLOGINREPLY, data.result) +
                            ")."
                    );
                    netLogin.end();

                    // ui.loginDialog(); // TODO: You cant redirect back to loginDialog for some reason
                    return;
                }

                waitDialog.close();

                if (autologin) {
                    this._doneSrvSel(autologin_serverId);
                } else {
                    const srvSelReq = ui.serverSelectDialog(data.servers);
                    srvSelReq.on("done", (serverId: any) => {
                        this._doneSrvSel(serverId);
                    });
                }
            });
        });
    }

    _doneSrvSel(serverId: any) {
        let waitDialog = ui.statusDialog();
        waitDialog.setMessage("Finding Server...");

        netLogin.channelList(serverId, (data: any) => {
            if (data.channels.length !== 1) {
                waitDialog.setMessage("More than one channel found!");
                netLogin.end();
                return;
            }

            waitDialog.setMessage("Found Server; Preparing to Connect...");

            const channelId = data.channels[0].id;
            console.log(
                "[Connecting] selected server and channel",
                serverId,
                channelId
            );
            netLogin.selectServer(serverId, channelId, (data: any) => {
                waitDialog.setMessage(
                    "Prepared; Connecting to Character Server..."
                );
                netLogin.end();

                netWorld = new WorldClient();
                netWorld.connect(
                    data.worldIp,
                    data.worldPort,
                    data.transferKey1,
                    activePass,
                    () => {
                        waitDialog.setMessage("Connected to World Server");
                        this._startCharSelect(waitDialog);
                    }
                );
            });
        });
    }

    _startCharSelect(waitDialog: any) {
        if (waitDialog === undefined) {
            waitDialog = ui.statusDialog();
        }

        waitDialog.setMessage("Downloading characters...");
        // TODO: Fix error where sometimes (in server) where the server does not send a 712 back

        netWorld.characterList((data: any) => {
            waitDialog.close();
            this._beginCharSelect(data);
        });
    }

    _beginCharSelect(charData: any) {
        const startPositionX = 5200;
        const startPositionZ = 5207;
        const startPositionY = 1.1;
        const offsetX = 2.75;
        const offsetZ = 0.5;
        const CHARPOSITIONS = [
            [startPositionX, startPositionZ, startPositionY],
            [
                startPositionX + offsetX,
                startPositionZ - offsetZ,
                startPositionY,
            ],
            [
                startPositionX - offsetX,
                startPositionZ - offsetZ,
                startPositionY,
            ],
            [
                startPositionX - offsetX * 1.8,
                startPositionZ - offsetZ * 4,
                startPositionY,
            ],
            [
                startPositionX + offsetX * 1.8,
                startPositionZ - offsetZ * 4,
                startPositionY,
            ],
        ];
        const CHARDIRECTION = 180; // 230;
        let CHARSCALE = 1.5;

        this.chars = charData.characters;

        console.log("[CharSelect]", charData);

        const listZones = GDM.getNow("list_zone");
        const zoneNames = GDM.getNow("zone_names");

        // Remove any previous characters!
        for (let i = 0; i < this.visChars.length; ++i) {
            scene.remove(this.visChars[i].rootObj);
        }

        this.visChars = [];

        for (let i = 0; i < charData.characters.length; ++i) {
            ((charIdx, charInfo) => {
                const charObj = new CharPawn();

                // Begin loading to prevent premature ready callbacks
                charObj.beginLoading();

                charObj.setGender(charInfo.gender, () => {
                    // Set face?
                    // charObj.setModelPart(AVTBODYPART.Face, charInfo.face);
                    // charObj.setModelPart(AVTBODYPART.Hair, charInfo.hairStyle);

                    // Set items
                    for (let j = 0; j < charInfo.parts.length; j++) {
                        // if (j === AVTBODYPART.Face || j === AVTBODYPART.Hair)
                        //     continue;
                        charObj.setModelPart(j, charInfo.parts[j].itemNo, 0);
                    }

                    charObj.visParts = charInfo.parts;

                    // End loading - this will trigger ready callbacks
                    charObj.endLoading();
                });

                charObj.rootObj.position.copy(
                    new THREE.Vector3(...CHARPOSITIONS[i])
                );
                charObj.setDirection((CHARDIRECTION / 180) * Math.PI);
                charObj.rootObj.scale.set(CHARSCALE, CHARSCALE, CHARSCALE);
                charObj.rootObj.visible = true;
                scene.add(charObj.rootObj);
                this.visChars.push(charObj);

                // Add Zone name on behalf of the CharSelDialog
                const zoneStrKey = listZones.item(charInfo.zoneNo, 26); // 65 (Forgotten Template (B1)?
                charInfo.zoneName = zoneNames.getByKey(zoneStrKey).text;
            })(i, charData.characters[i]);
        }

        // Wait for all characters to finish loading before playing animations and camera
        let loadedCount = 0;
        const startCameraAnimation = () => {
            this.playCamAnim(
                "canim_inselect",
                1,
                SETTINGS.LOGIN_SCREEN.INTRO_ANIMATION_SPEED,
                () => {
                    let dialog = ui.characterSelectDialog(charData.characters, charData.canManageGm);
                    dialog.on("selectionChanged", (characterIdx: any) => {
                        this.selectedCharIdx = characterIdx;
                        for (let i = 0; i < this.visChars.length; ++i) {
                            if (characterIdx === i) {
                                let visChar = this.visChars[i];
                                let char = this.chars[i];
                                if (char.deleteTime > 0) continue;

                                visChar.playJump1Motion(() => {
                                    visChar.playIdleMotion();
                                });
                                break;
                            }
                        }
                    });

                    if (autocharselect) {
                        // TODO: Remove later
                        this._doneCharSel(autologin_charname);
                        dialog.close();
                    }

                    dialog.on("done", (name: any) => this._doneCharSel(name));

                    dialog.on("create", () => {
                        dialog.hide();
                        this._beginCharacterCreate(dialog);
                    });

                    dialog.on("togglegm", () => {
                        const char = this.chars[this.selectedCharIdx];
                        if (!char || !char.name) return;

                        const next = !char.isGm;
                        netWorld.setCharacterGm(char.name, next, (data: any) => {
                            if (data.result === 0) {
                                char.isGm = next;
                                dialog._update();
                            } else {
                                ui.statusDialog("You are not allowed to change GM status.");
                            }
                        });
                    });

                    dialog.on("delete", (charParam: any) => {
                        const charIndex = this.selectedCharIdx;

                        const char = this.chars[charIndex];
                        const visChar = this.visChars[charIndex];

                        if (char.name) {
                            const doDelete = char.deleteTime ? 0 : 1;
                            netWorld.deleteCharacter(
                                charIndex,
                                char.name,
                                doDelete,
                                (data: any) => {
                                    char.deleteTime = data.deleteTime;

                                    visChar.whenReady(() => {
                                        if (char.deleteTime > 0) {
                                            visChar.playSittingMotion();
                                        } else {
                                            visChar.playIdleMotion();
                                        }
                                    });
                                    dialog._update();
                                }
                            );
                        }
                    });

                    // Force a selection so the model becomes visible
                    dialog.emit("selectionChanged", 0);
                }
            );
        };

        // Wait for all characters to load, then play animations and start camera
        for (let i = 0; i < this.visChars.length; i++) {
            this.visChars[i].whenReady(() => {
                loadedCount++;
                if (loadedCount === this.visChars.length) {
                    // All characters loaded, now play their animations
                    for (let j = 0; j < this.visChars.length; j++) {
                        ((visChar, char) => {
                            if (char.deleteTime > 0) {
                                visChar.playSittingMotion();
                            } else {
                                visChar.playIdleMotion();
                            }
                        })(this.visChars[j], this.chars[j]);
                    }

                    // All characters loaded and animating, start camera animation
                    startCameraAnimation();
                }
            });
        }

        // If there are no characters, start camera animation immediately
        if (this.visChars.length === 0) {
            startCameraAnimation();
        }
    }

    _beginCharacterCreate(charSelectDialog: any) {
        this.playCamAnim(
            "canim_create",
            1,
            SETTINGS.LOGIN_SCREEN.INTRO_ANIMATION_SPEED,
            undefined
        );

        // Hide all select characters
        //   for (let i = 0; i < this.visChars.length; ++i) {
        //     if (this.visChars[i].rootObj.visible) {
        //       visibleCharacter = this.visChars[i].rootObj;
        //     }
        //     this.visChars[i].rootObj.visible = false;
        //   }

        // Create our dummy character
        const charObj = new CharPawn();

        // Begin loading to prevent premature ready callbacks
        charObj.beginLoading();

        charObj.setGender(0, () => {
            for (let j = 0; j < AVTBODYPART.Max; ++j) {
                if (j === AVTBODYPART.Face || j === AVTBODYPART.Hair) {
                    charObj.setModelPart(j, 1, 0);
                } else {
                    charObj.setModelPart(j, 0, 0);
                }
            }
            // End loading - this will trigger ready callbacks
            charObj.endLoading();
        });

        const CHARPOSITION = new THREE.Vector3(5200, 5200, 7.5); // 5200, 5205, 5 //5742.0038, 5095.2579, 17.9782);
        const CHARSCALE = 2;
        charObj.rootObj.position.copy(CHARPOSITION);
        charObj.rootObj.rotateOnAxis(
            new THREE.Vector3(0, 0, 1),
            (200 / 180) * Math.PI // Turn the dummy a bit
        );
        charObj.rootObj.scale.set(CHARSCALE, CHARSCALE, CHARSCALE);
        charObj.rootObj.visible = true;

        scene.add(charObj.rootObj);

        // Play idle animation when character is ready
        charObj.whenReady(() => {
            charObj.playIdleMotion();
        });

        // Create our dialog
        const dialog = ui.characterCreateDialog();
        dialog.on("change_gender", (gender: any) => {
            charObj.setGender(gender, () => {});
        });

        dialog.on("change_face", (face: any) => {
            charObj.setModelPart(AVTBODYPART.Face, face, 0);
        });

        dialog.on("change_hair_style", (style: any) => {
            charObj.setModelPart(AVTBODYPART.Hair, style, 0);
        });

        //   dialog.on('change_hair_color', function(color) {
        //   });

        dialog.on(
            "create",
            (
                name: any,
                gender: any,
                face: any,
                hairStyle: any,
                hairColor: any
            ) => {
                netWorld.createCharacter(
                    name,
                    gender,
                    face,
                    hairStyle,
                    hairColor,
                    (data: any) => {
                        switch (data.result) {
                            case RESULT_CREATE_CHAR.OK:
                                dialog.close();
                                charSelectDialog.close();
                                scene.remove(charObj.rootObj);
                                this._startCharSelect(undefined); // TODO: Do simplified version of char select
                                break;
                            case RESULT_CREATE_CHAR.FAILED:
                                ui.messageBox(
                                    "Create character failed for unknown reason."
                                );
                                break;
                            case RESULT_CREATE_CHAR.DUP_NAME:
                                ui.messageBox(
                                    "Character name is already taken."
                                );
                                break;
                            case RESULT_CREATE_CHAR.INVALID_NAME:
                                ui.messageBox("Character name is invalid.");
                                break;
                            case RESULT_CREATE_CHAR.NO_MORE_SLOT:
                                ui.messageBox(
                                    "No more free character slots available."
                                );
                                break;
                            case RESULT_CREATE_CHAR.BLOCKED:
                                ui.messageBox("Create character is blocked.");
                                break;
                            case RESULT_CREATE_CHAR.NEED_PREMIUM:
                                ui.messageBox("Pay2win");
                                break;
                        }
                    }
                );
            }
        );

        dialog.on("cancel", () => {
            charSelectDialog.show();
            scene.remove(charObj.rootObj);
            this.playCamAnim(
                "canim_outselect",
                1,
                SETTINGS.LOGIN_SCREEN.INTRO_ANIMATION_SPEED,
                undefined
            );
        });
    }

    _doneCharSel(characterName: any) {
        const waitDialog = ui.statusDialog();
        waitDialog.setMessage("Selecting Character...");

        netWorld.selectCharacter(characterName, async (data: any) => {
            waitDialog.setMessage(
                "Character Selected; Connecting to Game Server..."
            );

            // The pregame state has to be prepared before, if it is not
            //   able to switch synchronously, we risk loosing events
            //   related to the character data.
            await StateManager.prepare("pregame");

            netGame = new GameClient();
            netGame.connect(
                data.gameIp,
                data.gamePort,
                data.transferKey1,
                activePass,
                () => {
                    waitDialog.close();
                    StateManager.switch("pregame");
                }
            );
        });
    }

    leave() {
        // Stop camera animation
        if (this.activeCamAnim) {
            this.activeCamAnim.stop();
            this.activeCamAnim = null;
        }

        // Remove all character models from scene
        for (let i = 0; i < this.visChars.length; ++i) {
            scene.remove(this.visChars[i].rootObj);
        }
        this.visChars = [];

        // Remove world from scene (includes map and music)
        if (this.world) {
            this.world.removeFromScene();
            this.world = null;
        }

        // Clear global.world reference to prevent it from being used in GameState
        global.world = null;

        // Close news dialog when leaving login state
        if (this.newsDialog) {
            this.newsDialog.close();
            this.newsDialog = null;
        }

        // Clear any remaining scene objects
        // Remove any orphaned objects that might still be in the scene
        const objectsToRemove = [];
        scene.traverse((obj: any) => {
            // Don't remove camera, renderer, or lights that are part of the base scene
            if (
                obj !== scene &&
                obj !== camera &&
                obj.type !== "AmbientLight" &&
                obj.type !== "DirectionalLight"
            ) {
                objectsToRemove.push(obj);
            }
        });
        for (let i = 0; i < objectsToRemove.length; ++i) {
            if (objectsToRemove[i].parent) {
                objectsToRemove[i].parent.remove(objectsToRemove[i]);
            }
        }
    }

    update(delta: any) {
        this.world.update(delta);
        for (let i = 0; i < this.visChars.length; ++i) {
            this.visChars[i].update(delta);
        }
    }
}

StateManager.register("login", LoginState);
